module.exports = __webpack_public_path__ + "img/explore-foodies.855dee18.png";